import { useEffect, lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './index.css'
import MainSite from './pages/MainSite'
import AdminDashboard from './pages/AdminDashboard'

const ServiceDetail = lazy(() => import('./pages/ServiceDetail'))
const ConstructionSEO = lazy(() => import('./pages/ConstructionSEO'))

function App() {
  useEffect(() => {
    // Hide native preloader once React hydrates
    const preloader = document.getElementById('native-preloader');
    if (preloader) {
      if (window.__preloaderInterval) clearInterval(window.__preloaderInterval);
      const bar = document.getElementById('native-preloader-bar');
      if (bar) bar.style.width = '100%';
      setTimeout(() => {
        preloader.style.opacity = '0';
        preloader.style.transition = 'opacity 0.3s ease';
        setTimeout(() => preloader.remove(), 300);
      }, 300);
    }
  }, [])

  return (
    <Router>
      <Suspense fallback={
        <div style={{ minHeight: '100vh', background: '#060e1c', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: 50, height: 50, border: '3px solid rgba(245,197,24,0.3)', borderTopColor: '#f5c518', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
          <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
      }>
        <Routes>
          <Route path="/" element={<MainSite />} />
          <Route path="/construction-services-delhi-ncr" element={<ConstructionSEO />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </Suspense>
    </Router>
  )
}

export default App
